// Helper functions for TabFilterButtons component

export const getTabId = (index) => `tab-${index}`
export const getPanelId = (index) => `panel-${index}`

export const getBorderColor = (props) => {
  if (props.enabled) {
    return props.setStatusBgColor ? props.setStatusBgColor(props) : '#1890ff'
  }
  return props.theme?.headerFilters?.headerFilterBgBorderColor || '#d9d9d9'
}

export const getBackgroundColor = (props) => {
  if (props.enabled) {
    return props.setStatusBgColor ? props.setStatusBgColor(props) : '#1890ff'
  }
  return 'transparent'
}

export const getTextColor = (props) => {
  return props.enabled
    ? props.theme?.headerFilters?.headerSelectedFilterTextColor || '#1890ff'
    : props.theme?.headerFilters?.headerFilterTextColor || '#666'
}
